import { theme } from '@prophecy/theme';
import React, { forwardRef, isValidElement } from 'react';

import { Stack } from '../Layout';
import { Tooltip, TooltipProps } from '../Tooltip';
import { useHint } from './Hint';
import { BaseText } from './styled';
import { TextProps } from './types';

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ level, hint, tooltip, tone, weight, elementType, children, ...rest }, ref) => {
    const _hint = useHint({ hint, level, tone });

    let childrenUI = children;

    if (_hint) {
      childrenUI = (
        <Stack gap={theme.spaces.x4} direction='horizontal' alignY='center'>
          {children}
          <>{_hint}</>
        </Stack>
      );
    }

    if (tooltip) {
      const tooltipProps =
        isValidElement(tooltip) || typeof tooltip === 'string'
          ? ({ title: tooltip, placement: 'top' } as TooltipProps)
          : (tooltip as TooltipProps);
      childrenUI = (
        <Tooltip {...tooltipProps}>
          <span>{childrenUI}</span>
        </Tooltip>
      );
    }

    return (
      <BaseText {...rest} tone={tone} weight={weight} as={elementType} level={level} ref={ref}>
        {childrenUI}
      </BaseText>
    );
  }
);
